import { dateTimeToView } from "helpers/date";
import Tooltip from "rc-tooltip";
import React, { useMemo } from "react";

export default function DriverShift(props) {
    const { item } = props;

    const driverShiftContent = useMemo(() => {
        if (!item.shiftData) {
            return null;
        }

        const {
            plannedEndDateOfCurrentShift,
            plannedStartDateOfNextShift,
            address,
            currentDriverFullName,
            nextDriverFullName,
            createdAt,
            updatedAt,
            comment,
        } = item.shiftData;
        return (
            <>
                <strong>Запланирована пересменка</strong>
                <div>
                    <strong className="pr-2">Плановая дата окончания последней смены:</strong>
                    <span>{dateTimeToView(plannedEndDateOfCurrentShift, "DD.MM.YYYY HH:mm (Z)")}</span>
                </div>
                <div>
                    <strong className="pr-2">Плановая дата начала смены:</strong>
                    <span>{dateTimeToView(plannedStartDateOfNextShift, "DD.MM.YYYY HH:mm (Z)")}</span>
                </div>
                <div>
                    <strong className="pr-2">Локация пересменки:</strong>
                    <span>{address}</span>
                </div>
                <div>
                    <strong className="pr-2">ФИО водителя последней смены:</strong>
                    <span>{currentDriverFullName || "Не назначен"}</span>
                </div>
                <div>
                    <strong className="pr-2">ФИО водителя новой смены:</strong>
                    <span>{nextDriverFullName || "Не назначен"}</span>
                </div>
                <div>
                    <strong className="pr-2">Дата создания пересменки:</strong>
                    <span>{dateTimeToView(createdAt, "DD.MM.YYYY HH:mm (Z)")}</span>
                </div>
                <div>
                    <strong className="pr-2">Последняя дата редактирования пересменки:</strong>
                    <span>{dateTimeToView(updatedAt, "DD.MM.YYYY HH:mm (Z)")}</span>
                </div>
                {comment && (
                    <div>
                        <strong className="pr-2">Комментарий:</strong>
                        <span>{comment}</span>
                    </div>
                )}
            </>
        );
    }, [item.shiftData]);
    return (
        <Tooltip overlayClassName="car-planning__tooltip" placement="bottomRight" overlay={driverShiftContent}>
            <i className="icon-uEAB2-people-arrows" />
        </Tooltip>
    );
}
